import { render } from "./FinancialYearsPage.vue?vue&type=template&id=e374da0c&ts=true"
import script from "./FinancialYearsPage.vue?vue&type=script&lang=ts"
export * from "./FinancialYearsPage.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__